import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { Modules, newNavigationName } from "config";
import CreateEnforcementTabletRequest from "entities/createEnforcementTabletRequest";
import { EnforcementTabletValidationRules } from "entities/enforcementTabletResponse";
import EnforcementTabletRepository from "repositories/enforcementTabletRepository";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import EventBus from "services/eventBus";
import CreateViewModel from "viewModels/createViewModel";

@Router.registerRoute({ route: newNavigationName, name: Router.Self })
export default class EnforcementTabletCreateViewModel extends CreateViewModel<CreateEnforcementTabletRequest> {
  readonly modelName = "enforcementTablet";

  constructor(
    protected localizationService: LocalizationService,
    protected repository: EnforcementTabletRepository,
    protected notificationService: NotificationService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  protected postData() {
    return this.repository.create(this.item);
  }

  protected loadDetail() {
    const item = new CreateEnforcementTabletRequest();
    item.isEnabled = false;

    attachAutomaticValidator(item, EnforcementTabletValidationRules);
    return item;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.enforcement, `enforcementTablets.${code}`, size);
  }
}
